import { createTheme, ThemeProvider } from '@mui/material';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';

const theme = createTheme({
  palette: {
    primary: {
      main: '#002169',
    },
  },
  typography: {
    fontFamily: ['Noto Sans JP', 'Inter', 'Arial'].join(', '),
    fontSize: 13,
  },

  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        size: 'large',
      },
      styleOverrides: {
        root: {
          margin: '2px',
        },
      },
      variants: [
        {
          props: { variant: 'contained', size: 'large' },
          style: {
            width: '200px',
            placeSelf: 'center',
          },
        },
        {
          props: { variant: 'outlined', size: 'large' },
          style: {
            width: '200px',
            placeSelf: 'center',
          },
        },
        {
          props: { variant: 'contained', size: 'small' },
          style: {
            width: '100px',
            fontSize: '12px',
            padding: '4px 12px',
          },
        },
      ],
    },
    MuiTableCell: {
      variants: [
        {
          props: { component: 'th' },
          style: {
            fontWeight: 'bold',
            fontSize: '16px',
            textAlign: 'center',
          },
        },
        {
          props: { component: 'td' },
          style: {
            textAlign: 'center',
          },
        },
      ],
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: `"Noto Sans JP", "Inter",  "Arial"`,
        },
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
